var map = {
	"./ad.svg": 10959,
	"./ae.svg": 26232,
	"./af-emirate.svg": 19118,
	"./af.svg": 78158,
	"./afar.svg": 75187,
	"./ag.svg": 6146,
	"./ai.svg": 63667,
	"./al.svg": 45669,
	"./am.svg": 44121,
	"./an.svg": 83845,
	"./ao.svg": 4178,
	"./aq-true_south.svg": 25025,
	"./aq.svg": 13618,
	"./ar.svg": 76996,
	"./as.svg": 67022,
	"./at.svg": 52160,
	"./au-aboriginal.svg": 48398,
	"./au-act.svg": 88562,
	"./au-nsw.svg": 78273,
	"./au-nt.svg": 37819,
	"./au-qld.svg": 17521,
	"./au-sa.svg": 4871,
	"./au-tas.svg": 95972,
	"./au-vic.svg": 62010,
	"./au-wa.svg": 9969,
	"./au.svg": 71918,
	"./aw.svg": 81566,
	"./ax.svg": 73897,
	"./az.svg": 71011,
	"./ba.svg": 37297,
	"./bb.svg": 45154,
	"./bd.svg": 19496,
	"./be.svg": 12769,
	"./bf.svg": 50626,
	"./bg.svg": 1336,
	"./bh.svg": 74690,
	"./bi.svg": 46297,
	"./bj.svg": 56290,
	"./bl.svg": 92442,
	"./bm.svg": 66354,
	"./bn.svg": 45346,
	"./bo.svg": 18407,
	"./br.svg": 15133,
	"./bs.svg": 54931,
	"./bt.svg": 8714,
	"./bw.svg": 34166,
	"./by.svg": 28102,
	"./bz.svg": 58454,
	"./ca-bc.svg": 49056,
	"./ca-qc.svg": 12803,
	"./ca.svg": 95911,
	"./cc.svg": 13533,
	"./cd.svg": 79151,
	"./cf.svg": 17838,
	"./cg.svg": 72206,
	"./ch-gr.svg": 96085,
	"./ch.svg": 512,
	"./ci.svg": 1400,
	"./ck.svg": 15233,
	"./cl.svg": 22295,
	"./cm.svg": 95014,
	"./cn-xj.svg": 66178,
	"./cn.svg": 41520,
	"./co.svg": 93434,
	"./cq.svg": 6205,
	"./cr.svg": 98987,
	"./cu.svg": 64603,
	"./cv.svg": 27900,
	"./cw.svg": 33286,
	"./cx.svg": 75897,
	"./cy.svg": 58227,
	"./cz.svg": 83926,
	"./de.svg": 52416,
	"./dj.svg": 24590,
	"./dk.svg": 74512,
	"./dm.svg": 39807,
	"./do.svg": 63388,
	"./dz.svg": 16156,
	"./earth.svg": 30516,
	"./east_african_federation.svg": 48897,
	"./easter_island.svg": 13445,
	"./ec-w.svg": 73298,
	"./ec.svg": 83044,
	"./ee.svg": 5801,
	"./eg.svg": 39779,
	"./eh.svg": 5269,
	"./er.svg": 19917,
	"./es.svg": 33170,
	"./et-or.svg": 51874,
	"./et-ti.svg": 71867,
	"./et.svg": 19034,
	"./european_union.svg": 72609,
	"./ewe.svg": 346,
	"./fi.svg": 73633,
	"./fj.svg": 29208,
	"./fk.svg": 54267,
	"./fm.svg": 8081,
	"./fo.svg": 60006,
	"./fr-20r.svg": 44295,
	"./fr-bre.svg": 49585,
	"./fr-cp.svg": 15891,
	"./fr.svg": 98069,
	"./ga.svg": 46606,
	"./gb.svg": 62554,
	"./gd.svg": 84063,
	"./ge-ab.svg": 5817,
	"./ge.svg": 96788,
	"./gf.svg": 29245,
	"./gg.svg": 72705,
	"./gh.svg": 16931,
	"./gi.svg": 52182,
	"./gl.svg": 80115,
	"./gm.svg": 38640,
	"./gn.svg": 47906,
	"./gp.svg": 95464,
	"./gq.svg": 42940,
	"./gr.svg": 63456,
	"./gs.svg": 99412,
	"./gt.svg": 34904,
	"./gu.svg": 83193,
	"./guarani.svg": 96648,
	"./gw.svg": 56217,
	"./gy.svg": 77325,
	"./hausa.svg": 57265,
	"./hk.svg": 4993,
	"./hmong.svg": 4290,
	"./hn.svg": 69567,
	"./hr.svg": 29482,
	"./ht.svg": 26782,
	"./hu.svg": 71947,
	"./id-jb.svg": 24273,
	"./id-jt.svg": 61728,
	"./id.svg": 34811,
	"./ie.svg": 51019,
	"./il.svg": 89173,
	"./im.svg": 8385,
	"./in.svg": 44205,
	"./io.svg": 25593,
	"./iq-kr.svg": 60596,
	"./iq.svg": 2795,
	"./ir.svg": 98558,
	"./is.svg": 8887,
	"./it.svg": 54351,
	"./je.svg": 37780,
	"./jm.svg": 30341,
	"./jo.svg": 50668,
	"./jp.svg": 29736,
	"./kanuri.svg": 34135,
	"./ke.svg": 52606,
	"./kg.svg": 93372,
	"./kh.svg": 33715,
	"./ki.svg": 71565,
	"./kikuyu.svg": 74313,
	"./km.svg": 68446,
	"./kn.svg": 15705,
	"./kongo.svg": 32246,
	"./kp.svg": 20313,
	"./kr.svg": 40966,
	"./kw.svg": 84797,
	"./ky.svg": 66422,
	"./kz.svg": 27661,
	"./la.svg": 27834,
	"./lb.svg": 67182,
	"./lc.svg": 7735,
	"./li.svg": 17361,
	"./lk.svg": 68494,
	"./lr.svg": 96030,
	"./ls.svg": 56089,
	"./lt.svg": 42608,
	"./lu.svg": 41763,
	"./lv.svg": 56305,
	"./ly.svg": 19975,
	"./ma.svg": 47797,
	"./malayali.svg": 35347,
	"./maori.svg": 57943,
	"./mars.svg": 658,
	"./mc.svg": 58986,
	"./md.svg": 81486,
	"./me.svg": 59925,
	"./mf.svg": 2600,
	"./mg.svg": 13067,
	"./mh.svg": 36458,
	"./mk.svg": 99941,
	"./ml.svg": 58248,
	"./mm.svg": 62387,
	"./mn.svg": 80878,
	"./mo.svg": 30743,
	"./mp.svg": 86831,
	"./mq-old.svg": 69386,
	"./mq.svg": 48351,
	"./mr.svg": 75430,
	"./ms.svg": 45847,
	"./mt.svg": 67164,
	"./mu.svg": 48880,
	"./mv.svg": 45270,
	"./mw.svg": 87032,
	"./mx.svg": 84925,
	"./my.svg": 55220,
	"./mz.svg": 63260,
	"./na.svg": 48932,
	"./nato.svg": 18887,
	"./nc.svg": 80706,
	"./ne.svg": 28348,
	"./nf.svg": 92707,
	"./ng.svg": 41057,
	"./ni.svg": 99789,
	"./nl-fr.svg": 57892,
	"./nl.svg": 58894,
	"./no.svg": 10970,
	"./northern_cyprus.svg": 59428,
	"./np.svg": 94847,
	"./nr.svg": 98570,
	"./nu.svg": 48454,
	"./nz.svg": 52273,
	"./occitania.svg": 83647,
	"./olympics.svg": 91199,
	"./om.svg": 67240,
	"./otomi.svg": 74399,
	"./pa.svg": 81463,
	"./pe.svg": 99210,
	"./pf.svg": 66039,
	"./pg.svg": 97089,
	"./ph.svg": 88213,
	"./pk-jk.svg": 82052,
	"./pk-sd.svg": 92259,
	"./pk.svg": 27256,
	"./pl.svg": 37319,
	"./pm.svg": 73854,
	"./pn.svg": 71060,
	"./pr.svg": 3315,
	"./ps.svg": 6310,
	"./pt-20.svg": 89478,
	"./pt-30.svg": 80300,
	"./pt.svg": 33516,
	"./pw.svg": 24158,
	"./py.svg": 36292,
	"./qa.svg": 6669,
	"./quechua.svg": 46719,
	"./re.svg": 73125,
	"./ro.svg": 3806,
	"./rs.svg": 57868,
	"./ru.svg": 89586,
	"./rw.svg": 54387,
	"./sa.svg": 93376,
	"./sami.svg": 45018,
	"./sb.svg": 65815,
	"./sc.svg": 91396,
	"./sd.svg": 53710,
	"./se.svg": 95564,
	"./sg.svg": 24597,
	"./sh-ac.svg": 54427,
	"./sh-hl.svg": 99479,
	"./sh-ta.svg": 16809,
	"./si.svg": 7513,
	"./sk.svg": 7385,
	"./sl.svg": 1512,
	"./sm.svg": 1179,
	"./sn.svg": 24642,
	"./so.svg": 25619,
	"./somaliland.svg": 32548,
	"./soviet_union.svg": 25226,
	"./sr.svg": 83556,
	"./ss.svg": 67159,
	"./st.svg": 165,
	"./sv.svg": 99113,
	"./sx.svg": 35139,
	"./sy.svg": 95280,
	"./sz.svg": 38369,
	"./tc.svg": 64535,
	"./td.svg": 18594,
	"./tf.svg": 40591,
	"./tg.svg": 12272,
	"./th.svg": 66978,
	"./tibet.svg": 73460,
	"./tj.svg": 53754,
	"./tk.svg": 65568,
	"./tl.svg": 45750,
	"./tm.svg": 9623,
	"./tn.svg": 65961,
	"./to.svg": 82696,
	"./torres_strait_islands.svg": 32165,
	"./tr.svg": 92610,
	"./transnistria.svg": 90243,
	"./tt.svg": 12097,
	"./tv.svg": 73521,
	"./tw.svg": 29568,
	"./tz.svg": 3686,
	"./ua.svg": 75303,
	"./ug.svg": 50525,
	"./united_nations.svg": 54908,
	"./us.svg": 45082,
	"./uy.svg": 2530,
	"./uz.svg": 14783,
	"./va.svg": 1309,
	"./vc.svg": 89630,
	"./ve.svg": 44490,
	"./vg.svg": 35176,
	"./vi.svg": 82016,
	"./vn.svg": 41972,
	"./vu.svg": 67584,
	"./wf.svg": 39259,
	"./wiphala.svg": 22469,
	"./ws.svg": 42977,
	"./xk.svg": 76250,
	"./xx.svg": 6559,
	"./ye.svg": 294,
	"./yorubaland.svg": 80752,
	"./yt.svg": 63815,
	"./yu.svg": 91796,
	"./za.svg": 84959,
	"./zm.svg": 36258,
	"./zw.svg": 83384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25272;